export default __webpack_public_path__ + "static/media/Putztucher.a9ad9e69.jpg";